import { createRoot, Root } from "react-dom/client";

// createRoot must be called once per DOM node and the resulting root reused for subsequent
// renders/unmounts, so we track the root created for each element here.
const roots = new WeakMap<Element, Root>();

export const getOrCreateRoot = (el: Element): Root => {
  let root = roots.get(el);
  if (!root) {
    root = createRoot(el);
    roots.set(el, root);
  }
  return root;
};

export const unmountRoot = (el: Element): void => {
  const root = roots.get(el);
  if (root) {
    root.unmount();
    roots.delete(el);
  }
};
